import { ContractWorkStatus } from '@apeiron/contract'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { Box, styled } from '@mui/material'
import PlanetSelectCard, {
  PlanetSelectCardProps
} from '@src/components/planet/share/planetCard/PlanetSelectCard'
import { FC, useMemo } from 'react'

const StyledPlanetSelectCard = styled(PlanetSelectCard)`
  .Custom-Overlay {
    background-color: #00000066;
  }
`

const Circle = styled(Box)`
  aspect-ratio: 1;
  border-radius: 50%;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Success = styled(Circle)`
  background-color: #000000aa;
`

const Fail = styled(Circle)`
  background-color: #fb4c00c3;
`

const Tick = styled(CheckIcon)`
  color: #28be1b;
  font-size: 50px;
`

const Cross = styled(CloseIcon)`
  font-size: 50px;
`

const PlanetSelectCardOnRental: FC<Props> = props => {
  const { planet } = props

  const status = planet?.workStatus ?? ContractWorkStatus.SUCCESS

  const Overlay = useMemo(() => {
    switch (status) {
      case ContractWorkStatus.SUCCESS:
        return (
          <Success>
            <Tick />
          </Success>
        )

      case ContractWorkStatus.FAIL:
        return (
          <Fail>
            <Cross />
          </Fail>
        )

      case ContractWorkStatus.IDLE:
      case ContractWorkStatus.OPERATING:
      default:
        return null
    }
  }, [status])

  return <StyledPlanetSelectCard {...props} overlay={Overlay} />
}

type Props = PlanetSelectCardProps

export default PlanetSelectCardOnRental
